<div class="menu-trigger-dummy" [matMenuTriggerFor]="resultsMenu"></div>
<input id="advanced-search-input"
       *ngIf="advancedSearchService.searchConfigLoaded"
       class="case-search-input"
       [formControl]="inputControl"
       [placeholder]="placeholderText | translate"
       (focus)="onFocus()"
>
<i class="icon__search"></i>
<!--TODO: Make this a modal -->

<mat-menu #resultsMenu="matMenu" [overlapTrigger]="false">
    <div class ="background-container">
        <div class="case-search-results-container">
            <ng-container *ngFor="let searchResult of searchResults$ | async">
                <gen-search-result-table *ngIf="searchResult?.length > 0"
                                         (rowSelected)="onRowSelected($event)"
                                         [columnDefs]="displayConfigToColumnDefs(searchResult)"
                                         [rowData]="searchResult"
                                         [title]="tableTitle(searchResult)"
                                         [id]="searchResult[0].searchType + '-search-results'"
                ></gen-search-result-table>
            </ng-container>
        </div>
    </div>
</mat-menu>
